import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { PLACEMENTS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/placements/")({
  component: () => <DeptContentList cfg={PLACEMENTS} />,
});
